import Gallery from "../../../../src/components/gallery";
import * as React from 'react';
export default {
  Gallery,
  React
};